import { IResponse, fetchData } from '@umu/umu-fetch';
import { API } from '../api';
import { IDepartmentSearchParams, IDepartmentSearchRes, IMemberInfo, MEMBER_TYPE, SWITCH_STATUS } from '../interface';
import { defaultDepartmentData } from './defaultData/knowledgePoint';
/** 此接口与知识点部门结构获取接口一致 */
const getWorkspaceDepartmentList = (params: IDepartmentSearchParams): Promise<IDepartmentSearchRes> => {
    return fetchData(API.GET_WORKSPACE_DEPARTMENT_LIST, params, { silent: true }).then(
        (res: IResponse<IDepartmentSearchRes>) => {
            return res.data || defaultDepartmentData;
        },
        () => {
            return defaultDepartmentData;
        },
    );
};

interface DepPath {
    department_id: string;
    level: string;
    department_name: string;
    is_del: string;
}
interface DTO {
    department_id: string;
    enterprise_id: string;
    parent_department_id: string;
    level: string;
    department_name: string;
    show_index: string;
    parent_path: DepPath[];
    member_count: number;
    managers: any[];
    manage_permission: number;
    child_path: DepPath[];
    department_name_highlight: string;
}

const toMemberVO = (dto: DTO): IMemberInfo => {
    return {
        id: dto.department_id,
        name: dto.department_name,
        email: '',
        login_name: '',
        phone: '',
        type: MEMBER_TYPE.DEPARTMENT,
        user_num: dto.member_count,
        avatar: '',
        is_manage: dto.manage_permission,
        is_department_manager: SWITCH_STATUS.YES,
        path: dto.parent_path.map((item) => ({ id: item.department_id, name: item.department_name, parent_id: '' })),
    };
};

const getWorkspaceDepartmentSearchList = (name = ''): Promise<IMemberInfo[]> => {
    return fetchData(
        API.GET_WORKSPACE_DEPARTMENT_SEARCH_LIST,
        {
            keywords: name,
        },
        { silent: true },
    ).then(
        (res: IResponse<DTO[]>) => {
            return res.data.map((item) => toMemberVO(item)) || [];
        },
        () => {
            return [];
        },
    );
};
export { getWorkspaceDepartmentList, getWorkspaceDepartmentSearchList };
